import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Navbar.css';

const Navbar = ({ theme, toggleTheme }) => {
  const { user, logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <img src="/Logo.png" alt="David Goodman Prime Time Logo" className="navbar-logo" />
          <span>Prime Time</span>
        </Link>
        
        <button className="burger-menu" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={isMenuOpen ? 'burger-line open' : 'burger-line'}></span>
          <span className={isMenuOpen ? 'burger-line open' : 'burger-line'}></span>
          <span className={isMenuOpen ? 'burger-line open' : 'burger-line'}></span>
        </button>
        
        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <button onClick={toggleTheme} className="theme-toggle" title="Toggle theme">
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
          </li>
          <li className="navbar-item">
            <Link to="/" className="navbar-link" onClick={closeMenu}>Home</Link>
          </li>
          <li className="navbar-item">
            <Link to="/about" className="navbar-link" onClick={closeMenu}>About</Link>
          </li>
          <li className="navbar-item">
            <Link to="/contact-us" className="navbar-link" onClick={closeMenu}>Contact Us</Link>
          </li>
          
          {user ? (
            <>
              <li className="navbar-item">
                <Link to="/create-blog" className="navbar-link" onClick={closeMenu}>Create Blog</Link>
              </li>
              <li className="navbar-item">
                <Link to="/my-blogs" className="navbar-link" onClick={closeMenu}>My Blogs</Link>
              </li>
              {user.role === 'admin' && (
                <li className="navbar-item">
                  <Link to="/admin" className="navbar-link navbar-admin" onClick={closeMenu}>Admin Panel</Link>
                </li>
              )}
              <li className="navbar-item">
                <span className="navbar-user">Welcome, {user.name}</span>
              </li>
              <li className="navbar-item">
                <button onClick={() => { logout(); closeMenu(); }} className="navbar-button">Logout</button>
              </li>
            </>
          ) : (
            <>
              <li className="navbar-item">
                <Link to="/signin" className="navbar-link" onClick={closeMenu}>Sign In</Link>
              </li>
              <li className="navbar-item">
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
